// import { errorRegisterToast, errorToast } from "components/notifications";

export const validationPhone = (values) => {
  const errors = {}
  if (!values.phone || values.phone === true) {
    errors.phone = 'Обязательное поле'
  }
  if (values.phone && values.phone.length < 18) {
    errors.phone = 'Не правильный формат телефона'
  }
  return errors
}

export const validationSms = (values) => {
  const errors = {}
  if (!values.sms) {
    errors.sms = 'Обязательное поле'
  }

  if (values.sms && values.sms.length < 6) {
    errors.sms = 'Обязательное поле'
  }

  return errors
}

export const validationCallback = (values) => {
  const errors = {}
  if (!values.name) {
    errors.name = 'Обязательное поле'
  }
  if (!values.mail) {
    errors.mail = 'Обязательное поле'
  }
  if (
    values.mail &&
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.mail)
  ) {
    errors.mail = 'Неверный адрес электронной почты'
  }
  if (!values.comment.length > 0) {
    errors.comment = 'Обязательное поле'
  }

  return errors
}

export const validationRegistration = (values, transLate) => {
  const errors = {}
  if (!values.name) {
    errors.name = transLate('required')
  }
  if (!values.surname) {
    errors.surname = transLate('required')
  }
  if (!values.birthday) {
    errors.birthday = transLate('required')
  }
  if (values.birthday && values.birthday === '') {
    errors.birthday = transLate('required')
  }
  if (!values.email) {
    errors.email = transLate('required')
  }
  if (
    values.email &&
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
  ) {
    errors.email = transLate('invalidMail')
  }
  if (!values.sex) {
    errors.sex = transLate('required')
  }
  if (!values.country_id) {
    errors.country_id = transLate('required')
  }
  if (!values.citizenship_id) {
    errors.citizenship_id = transLate('required')
  }
  if (!values.password) {
    errors.password = transLate('required')
  }
  if (values && values.password && values.password.length <= 5) {
    errors.password = transLate('passLength')
  }
  if (!values.passwordConfirm) {
    errors.passwordConfirm = transLate('required')
  }
  if ((values.passwordConfirm && values.password) && values.passwordConfirm !== values.password) {
    errors.passwordConfirm = 'Пароли не совпадают'
  }
  if(!values.photo) {
    errors.photo = transLate('required')
  }
  if(!values.passportPhoto) {
    errors.passportPhoto = transLate('required')
  }
  if (!values.passport?.number) {
    errors.passport = { ...errors.passport }
    errors.passport.number = transLate('required')
  }
  if (!values.passport?.create_date) {
    errors.passport = { ...errors.passport }
    errors.passport.create_date = transLate('required')
  }
  if (!values.job?.position) {
    errors.job = { ...errors.job }
    errors.job.position = transLate('required')
  }
  if (!values.job?.organisation_name) {
    errors.job = { ...errors.job }
    errors.job.organisation_name = transLate('required')
  }
  if (!values.phone) {
    errors.phone = transLate('required')
  }
  // if (!values.flight_schedules?.input?.name) {
  //   errors.flight_schedules = {...errors.flight_schedules}
  //   errors.flight_schedules.input = {...errors.flight_schedules.input }
  //   errors.flight_schedules.input.name = transLate('required')
  // }
  // if (!values.flight_schedules.input.date) {
  //   errors.flight_schedules = {...errors.flight_schedules}
  //   errors.flight_schedules.input = {...errors.flight_schedules.input }
  //   errors.flight_schedules.input.date = transLate('required')
  // }
  // if (!values.flight_schedules.input.time) {
  //   errors.flight_schedules = {...errors.flight_schedules}
  //   errors.flight_schedules.input = {...errors.flight_schedules.input }
  //   errors.flight_schedules.input.time = transLate('required')
  // }
  // if (!values.flight_schedules.exit.name) {
  //   errors.flight_schedules = {...errors.flight_schedules}
  //   errors.flight_schedules.exit = {...errors.flight_schedules.exit}
  //   errors.flight_schedules.exit.name = transLate('required')
  // }
  // if (!values.flight_schedules.exit.date) {
  //   errors.flight_schedules = {...errors.flight_schedules}
  //   errors.flight_schedules.exit = {...errors.flight_schedules.exit}
  //   errors.flight_schedules.exit.date = transLate('required')
  // }
  // if (!values.flight_schedules.exit.time) {
  //   errors.flight_schedules = {...errors.flight_schedules}
  //   errors.flight_schedules.exit = {...errors.flight_schedules.exit}
  //   errors.flight_schedules.exit.time = transLate('required')
  // }
  // if (!values.food) {
  //   errors.food = transLate('required')
  // }

  if (!values.personal_data_confirmation) {
    errors.personal_data_confirmation = transLate('required')
  }

  return errors
}

export const validationProfile = (values, transLate) => {
  const errors = {}
  if (!values.name) {
    errors.name = transLate('required')
  }
  if (!values.surname) {
    errors.surname = transLate('required')
  }
  if (!values.birthday) {
    errors.birthday = transLate('required')
  }
  if (values.birthday && values.birthday === '') {
    errors.birthday = transLate('required')
  }
  if (!values.email) {
    errors.email = transLate('required')
  }
  if (
    values.email &&
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
  ) {
    errors.email = 'Не верный адрес электронной почты'
  }
  if (!values.sex) {
    errors.sex = transLate('required')
  }
  if (!values.country_id) {
    errors.country_id = transLate('required')
  }
  if (!values.citizenship_id) {
    errors.citizenship_id = transLate('required')
  }
  if (!values.passport?.number) {
    errors.passport = { ...errors.passport }
    errors.passport.number = transLate('required')
  }
  if (!values.passport?.create_date) {
    errors.passport = { ...errors.passport }
    errors.passport.create_date = transLate('required')
  }
  if (!values.job?.position) {
    errors.job = { ...errors.job }
    errors.job.position = transLate('required')
  }
  if (!values.job?.organisation_name) {
    errors.job = { ...errors.job }
    errors.job.organisation_name = transLate('required')
  }
  if (!values.phone) {
    errors.phone = transLate('required')
  }
  // if (!values.flight_schedules?.input?.name) {
  //   errors.flight_schedules = {...errors.flight_schedules}
  //   errors.flight_schedules.input = {...errors.flight_schedules.input }
  //   errors.flight_schedules.input.name = transLate('required')
  // }
  // if (!values.flight_schedules.input.date) {
  //   errors.flight_schedules = {...errors.flight_schedules}
  //   errors.flight_schedules.input = {...errors.flight_schedules.input }
  //   errors.flight_schedules.input.date = transLate('required')
  // }
  // if (!values.flight_schedules.input.time) {
  //   errors.flight_schedules = {...errors.flight_schedules}
  //   errors.flight_schedules.input = {...errors.flight_schedules.input }
  //   errors.flight_schedules.input.time = transLate('required')
  // }
  // if (!values.flight_schedules.exit.name) {
  //   errors.flight_schedules = {...errors.flight_schedules}
  //   errors.flight_schedules.exit = {...errors.flight_schedules.exit}
  //   errors.flight_schedules.exit.name = transLate('required')
  // }
  // if (!values.flight_schedules.exit.date) {
  //   errors.flight_schedules = {...errors.flight_schedules}
  //   errors.flight_schedules.exit = {...errors.flight_schedules.exit}
  //   errors.flight_schedules.exit.date = transLate('required')
  // }
  // if (!values.flight_schedules.exit.time) {
  //   errors.flight_schedules = {...errors.flight_schedules}
  //   errors.flight_schedules.exit = {...errors.flight_schedules.exit}
  //   errors.flight_schedules.exit.time = transLate('required')
  // }
  // if (!values.food) {
  //   errors.food = transLate('required')
  // }
  return errors
}

export const validateText = (value) => {
  let errorMessage
  if (!value) {
    errorMessage = 'Обязательное поле'
  }
  return errorMessage
}

export const validateObj = (value) => {
  let errorMessage
  if (!value || !value.name) {
    errorMessage = 'Обязательное поле'
  }
  return errorMessage
}
